export default function formatDateString(date) {
  return new Date(date).toLocaleDateString("en-AU", {
    year: "numeric", month: "long", day: "numeric"
  })
}